module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.formClass,
      "label-width": "70px"
    }
  }, [(_vm.invitaCodeObj.type != 1) ? _c('el-form-item', {
    attrs: {
      "label": "兑换码:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "",
      "size": "small"
    },
    model: {
      value: (_vm.formClass.subCouponName),
      callback: function($$v) {
        _vm.$set(_vm.formClass, "subCouponName", $$v)
      },
      expression: "formClass.subCouponName"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "生成日期:",
      "label-width": "80px"
    }
  }, [_c('DatePicker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placement": "bottom-end",
      "clearable": true
    },
    model: {
      value: (_vm.formClass.createdTime),
      callback: function($$v) {
        _vm.$set(_vm.formClass, "createdTime", $$v)
      },
      expression: "formClass.createdTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "UID:"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formClass.Uid),
      callback: function($$v) {
        _vm.$set(_vm.formClass, "Uid", $$v)
      },
      expression: "formClass.Uid"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态:"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "175px"
    },
    attrs: {
      "clearable": "",
      "size": "small"
    },
    model: {
      value: (_vm.formClass.status),
      callback: function($$v) {
        _vm.$set(_vm.formClass, "status", $$v)
      },
      expression: "formClass.status"
    }
  }, _vm._l((_vm.statusGoods), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "search"
    },
    on: {
      "click": _vm.onQuery
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e9cd61c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/operation/components/queryInvitationDetail.vue
// module id = 703
// module chunks = 1